import styled from '@emotion/styled';

type ContainerSCProps = {
  containerWidth?: string;
  containerHeight?: string;
  display?: string;
  isFirstLine?: boolean;
  margin?: string;
  textAlign?: string;
};

export const ContainerSC = styled.div<ContainerSCProps>`
  width: ${({ containerWidth }) => (containerWidth ? containerWidth : '100%')};
  height: ${({ containerHeight }) =>
    containerHeight ? containerHeight : 'initial'};
  display: ${({ display }) => display};
  margin: ${({ margin }) => margin};
  text-align: ${({ textAlign }) => (textAlign ? textAlign : 'initial')};
  @media (max-width: 698px) {
    margin: ${({ isFirstLine }) => (isFirstLine ? '0 0 23px 0' : '')};
  }
`;
